import React, {useEffect, useState} from 'react'
import Header from "../../layout/header";
import ReactPaginate from "react-paginate";
import Loader from "../../../Loader/Loader";
import NotFoundData from "../../../Images/no-data-found.webp";
import DashboardMenu from "../../layout/dashboardMenu";
import Moment from "moment";

const TaggedActivityList = ({
                                taggedAlongList,
                                taggedList = [],
                                match,
                                history
                            }) => {

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await taggedAlongList()
            setIsLoading(false)
        })()
    }, [])

    const onPageChange = async (val) => {
        setIsLoading(true)
        await taggedAlongList(val?.selected + 1)
        setIsLoading(false)
    };

    return (
        <>
            <Loader isLoading={isLoading}/>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Activity List'}
                            history={history}
                        />
                        <div className="container-fluid">
                            {/*Heading*/}
                                <div className="container-fluid bootstrap snippets bg-white">
                                    <div className="d-sm-flex align-items-center justify-content-between mb-2 bg-white">
                                        <div className="row col-md-12">

                                        </div>
                                    </div>
                                <div className="row mt-10">
                                    {taggedList && taggedList?.data !== undefined && taggedList?.data.length > 0 && taggedList?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow card-padding">
                                                        <div className="card card-just-text"
                                                             data-background="color"
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category">
                                                                    {parseInt(val?.tagged_status) === 0 ?
                                                                        <div className="header-ui-item-opp"
                                                                             style={{backgroundColor: "#bea925"}}>
                                                                            Pending
                                                                        </div> : parseInt(val?.tagged_status) === 1 ?
                                                                            <div className="header-ui-item-opp">
                                                                                Approved
                                                                            </div> : parseInt(val?.tagged_status) === 2 ?
                                                                                <div
                                                                                    className="header-ui-item-opp"
                                                                                    style={{backgroundColor: "#88130a"}}>
                                                                                    Rejected
                                                                                </div> : ""
                                                                    }

                                                                    <div className="row">
                                                                        <div className="col-10" style={{
                                                                            color: "#000",
                                                                            fontSize: "20px",
                                                                            textAlign: "left",
                                                                            paddingLeft: "20px"
                                                                        }}>
                                                                                    <span
                                                                                        className="">{val?.name}
                                                                                    </span>
                                                                        </div>
                                                                        <div className="col-2">
                                                                            {/*TOGGLE*/}
                                                                            <div className="dropdown"
                                                                                 style={{"float": "right"}}>
                                                                                <i className="bi bi-three-dots-vertical" data-toggle="dropdown" style={{color:"black"}}></i>
                                                                                <ul className="dropdown-menu">
                                                                                    <li><a
                                                                                        href={`view-tagged-along-activity/${val?.activity_id}/${val?.tagged_id}`}
                                                                                        className="btn btn-sm"
                                                                                        type="button"
                                                                                    >Action</a>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                            {/*TOGGLE END*/}
                                                                        </div>
                                                                    </div>
                                                                    <div className="row list-view">
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-building"></i>&nbsp;&nbsp;Activity
                                                                                Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{Moment(val?.activity_date).format('DD-MM-YYYY HH:mm:ss')}
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-person-check-fill"></i>&nbsp;&nbsp;Created
                                                                                By
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.user_name}
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-person-check-fill"></i>&nbsp;&nbsp;Assigned
                                                                                To
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.assign_to}
                                                                            </div>
                                                                        </div>

                                                                        {val?.meta_data?.remark !== undefined && val?.meta_data?.remark !== '' &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-person-check-fill"></i>&nbsp;&nbsp;Remarks
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.meta_data?.remark}>
                                                                                        {val?.meta_data?.remark}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {val?.dropped_reason !== '' && val?.dropped_reason !== null &&
                                                                            <>
                                                                                <div className="mb-flex">
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6 no-wrap">
                                                                                        <i className="fa fa-ban"
                                                                                           aria-hidden="true"></i>&nbsp;&nbsp;Dropped
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6">{val?.dropped_reason}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="mb-flex">
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6 no-wrap">
                                                                                        <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Dropped
                                                                                        Date
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6">{Moment(val?.updated_at).format('DD-MM-YYYY')}
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Created
                                                                                Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{Moment(val?.created_at).format('DD-MM-YYYY')}
                                                                            </div>
                                                                        </div>
                                                                        {val?.purpose !== undefined && val?.purpose != null && val?.purpose !== '' &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fas fa-bus-alt"></i>&nbsp;&nbsp;Purpose
                                                                                    of visit
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">
                                                                                            <span className="trigger"
                                                                                                  data-tooltip-id="2"
                                                                                                  title={val?.purpose}>
                                                                                        {val?.purpose}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {val?.cStage !== undefined && val?.cStage != null && val?.cStage !== '' &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fas fa-door-closed"></i>&nbsp;&nbsp;Client
                                                                                    Stage
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">
                                                                                            <span className="trigger"
                                                                                                  data-tooltip-id="3"
                                                                                                  title={val?.cStage}>
                                                                                                    {val?.cStage}
                                                                                                </span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>

                                                                    <hr/>
                                                                </h6>
                                                                {/*<div className="col-sm-6">*/}
                                                                {/*    <a href={`/dealer-activity/${val?.dealer_id}/ncd`}*/}
                                                                {/*       className="draft-float">*/}
                                                                {/*        <p className="my-float"*/}
                                                                {/*           style={{marginTop: "20px"}}>*/}
                                                                {/*            <i className="fa fa-plus"*/}
                                                                {/*               aria-hidden="true"></i>*/}
                                                                {/*        </p>*/}
                                                                {/*    </a>*/}
                                                                {/*</div>*/}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                    {taggedList && taggedList?.data !== undefined && taggedList?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(taggedList?.total / taggedList?.per_page)}
                                                forcePage={taggedList?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }
                                    {taggedList && taggedList?.data !== undefined && taggedList?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" alt={""}/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                            {/*<div className="col-sm-6">*/}
                                            {/*    <a href={`/dealer-activity/${match?.params?.dealer_id}/ncd`}*/}
                                            {/*       className="draft-float">*/}
                                            {/*        <p className="my-float" style={{marginTop: "20px"}}><i*/}
                                            {/*            className="fa fa-plus"*/}
                                            {/*            aria-hidden="true"></i></p>*/}
                                            {/*    </a>*/}
                                            {/*</div>*/}
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* section ends */}
        </>
    )
}

export default TaggedActivityList